module.exports = __webpack_public_path__ + "assets/shape-square.74dd1051.svg";